// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Logo$BenfaerberBlog from "../components/Logo.bs.js";
import * as AppContext$BenfaerberBlog from "../AppContext.bs.js";

function s(prim) {
  return prim;
}

function Footer(props) {
  var match = React.useState(function () {
        return false;
      });
  var setLogoPicker = match[1];
  var match$1 = React.useContext(AppContext$BenfaerberBlog.context);
  var setTheme = match$1.setTheme;
  var setLogo = match$1.setLogo;
  var theme = match$1.theme;
  var onClickMainLogo = function (param) {
    setLogoPicker(function (param) {
          return true;
        });
  };
  var onClickChangeTheme = function (param) {
    var newTheme;
    newTheme = theme === "Light" ? "Dark" : "Light";
    setTheme(newTheme);
  };
  var logoPicker = JsxRuntime.jsx("div", {
        children: Belt_Array.mapWithIndex(Logo$BenfaerberBlog.allLogos, (function (i, logo) {
                return JsxRuntime.jsx("span", {
                            children: Logo$BenfaerberBlog.asEmoji(logo),
                            className: "footer-logo",
                            onClick: (function (param) {
                                setLogo(logo);
                                setLogoPicker(function (param) {
                                      return false;
                                    });
                              })
                          }, String(i));
              }))
      });
  var iconName;
  iconName = theme === "Light" ? "moon" : "sun";
  var themeIcon = JsxRuntime.jsx("i", {
        className: "uil uil-" + iconName
      });
  return JsxRuntime.jsxs("footer", {
              children: [
                JsxRuntime.jsx("div", {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("h2", {
                                      children: [
                                        "What the Functor? ",
                                        match[0] ? logoPicker : JsxRuntime.jsx("span", {
                                                children: Logo$BenfaerberBlog.asEmoji(match$1.logo),
                                                className: "footer-logo",
                                                onClick: onClickMainLogo
                                              })
                                      ],
                                      className: "is-flex is-justify-content-center is-align-items-center"
                                    }),
                                JsxRuntime.jsxs("h3", {
                                      children: [
                                        "Functional programming for ",
                                        JsxRuntime.jsx("a", {
                                              children: "fun",
                                              style: {
                                                color: "#4a4a4a"
                                              },
                                              href: "/videos/terry.mp4"
                                            }),
                                        " and profit!"
                                      ]
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              className: "mb-2"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("a", {
                                      children: [
                                        JsxRuntime.jsx("i", {
                                              className: "uil uil-github-alt"
                                            }),
                                        " @benfaerber"
                                      ],
                                      className: "monospace footer-link",
                                      href: "https://github.com/benfaerber",
                                      rel: "noreferrer",
                                      target: "_blank"
                                    }),
                                JsxRuntime.jsx("span", {
                                      style: {
                                        paddingLeft: "20px"
                                      }
                                    }),
                                JsxRuntime.jsxs("a", {
                                      children: [
                                        JsxRuntime.jsx("i", {
                                              className: "uil uil-linkedin-alt"
                                            }),
                                        " @ben-faerber"
                                      ],
                                      className: "monospace footer-link",
                                      href: "https://www.linkedin.com/in/ben-faerber/",
                                      rel: "noreferrer",
                                      target: "_blank"
                                    }),
                                JsxRuntime.jsx("span", {
                                      style: {
                                        paddingLeft: "20px"
                                      }
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: themeIcon,
                                      className: "button theme-button",
                                      onClick: onClickChangeTheme
                                    })
                              ],
                              className: "is-flex is-align-items-center is-justify-content-center"
                            })
                      ]
                    })
              ],
              className: "footer w100 is-flex is-align-items-center is-justify-content-center"
            });
}

var make = Footer;

export {
  s ,
  make ,
}
/* react Not a pure module */
